export var _toSingle = function (fn) { return Object.assign(fn, { single: true }); };
